module.exports = __webpack_public_path__ + "img/aej1n-66wvl.018.9df672c9.png";